import { DonateForm } from '@/components/forms/DonateForm'
import { CosmosCrest } from '@/components/brand/CosmosCrest'
import { Reveal } from '@/components/motion/Reveal'

export function DonatePage() {
  return (
    <div className="py-24">
      <div className="container-narrow grid gap-10 md:grid-cols-2 items-start">
        <Reveal>
          <span className="eyebrow eyebrow-gold">Support The Club</span>
          <h1 className="mt-3 font-display text-display-2 uppercase">Donate to Cosmos.</h1>
          <p className="mt-6 text-muted-foreground text-lg leading-relaxed">
            Every dollar keeps kids in cleats. We are a registered 501(c)(3) non-profit — donations are tax-deductible.
          </p>
          <div className="mt-6 grid grid-cols-2 gap-4">
            <ImpactStat n="$50" label="One month of training kit" />
            <ImpactStat n="$150" label="A season of league fees for one player" />
            <ImpactStat n="$375" label="A full Advance-camp scholarship" />
            <ImpactStat n="$1000" label="Sponsors a Jamaica program month" />
          </div>
          <div className="mt-10 flex justify-center">
            <CosmosCrest size={180} animated />
          </div>
        </Reveal>

        <div className="rounded-2xl border border-border bg-card p-8">
          <DonateForm />
        </div>
      </div>
    </div>
  )
}

function ImpactStat({ n, label }: { n: string; label: string }) {
  return (
    <div className="rounded-xl border border-border p-4">
      <div className="font-display text-2xl text-cosmos-green num">{n}</div>
      <div className="text-xs text-muted-foreground mt-1">{label}</div>
    </div>
  )
}
